/* session.svelte.js generated by Svelte v5.56.9 */
import * as $ from 'svelte/internal/client';
import api from "./api.js";
import { enableSync, pullRemotePrefs, snapshot } from "./prefs.svelte.js";

export const session = $.tag_proxy($.proxy({ user: null, googleEnabled: false, loaded: false }), 'session');
export const isAdmin = () => $.strict_equals(session.user?.role, "admin");

export async function loadSession() {
	try {
		const response = (await $.track_reactivity_loss(api.session()))();

		session.user = response?.user ?? null;
		session.googleEnabled = response?.googleEnabled ?? false;
	} catch {
		session.user = null;
	} finally {
		session.loaded = true;
		(await $.track_reactivity_loss(afterSessionChange()))();
	}
}

export function setUser(user) {
	session.user = user ?? null;

	return afterSessionChange();
}

export async function logout() {
	try {
		(await $.track_reactivity_loss(api.logout()))();
	} finally {
		session.user = null;
		enableSync(false);
	}
}

/**
 * Signing in adopts the local preferences (so a visitor's anonymous browsing isn't lost)
 * and then folds in whatever the account already knew.
 */
async function afterSessionChange() {
	if (!session.user) {
		enableSync(false);

		return;
	}

	enableSync(true);
	(await $.track_reactivity_loss(pullRemotePrefs()))();
	api.mergePreferences(snapshot()).catch(() => {});
}